const ModuleState = ({ loading, error, availability, onRetry }) => {
  if (loading) return <section className="director-state" role="status">Carregando leitura executiva…</section>;
  if (error) return <section className="director-state director-state--error" role="alert">
    <strong>{error.message || "Não foi possível carregar esta leitura."}</strong>
    {error.retryable && <button className="director-button" type="button" onClick={onRetry}>Tentar novamente</button>}
  </section>;
  if (availability?.status === "empty" || availability === "empty") {
    return <section className="director-state">
      <strong>Nenhum dado neste recorte</strong>
      <p>Ajuste os filtros ou aguarde a próxima materialização financeira.</p>
    </section>;
  }
  return null;
};

export default ModuleState;
